import { IonImg } from '@ionic/react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { ParametersProps } from '../../wizard/WizardSteps';

export const LanguageParameters: React.FC<ParametersProps> = ({
  updateParameter,
  user,
  parameters,
  isSetLoading,
}) => {
  useEffect(() => {
    isSetLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ul className="mt-4 mx-auto">
      <li className="py-2 flex justify-between items-center">
        <div className="flex items-center">
          <IonImg className="w-7 rounded-full" src="assets/img/fr.png" />
          <p className="mx-4 text-black">
            <FormattedMessage id="French" />
          </p>
        </div>
        <input
          className="form-radio w-5 h-5 text-primary border-lightGrey focus:ring-primary"
          name="locale"
          type="radio"
          value="fr_FR"
          checked={parameters.locale === 'fr_FR'}
          onChange={(event) =>
            updateParameter(event.target.name, event.target.value)
          }
        />
      </li>
      <li className="py-2 flex justify-between items-center">
        <div className="flex items-center">
          <IonImg className="w-7 rounded-full" src="assets/img/uk.png" />
          <p className="mx-4 text-black">
            <FormattedMessage id="English" />
          </p>
        </div>
        <input
          className="form-radio w-5 h-5 text-primary border-lightGrey focus:ring-primary"
          name="locale"
          type="radio"
          value="en_US"
          checked={parameters.locale === 'en_US'}
          onChange={(event) =>
            updateParameter(event.target.name, event.target.value)
          }
        />
      </li>
    </ul>
  );
};
